import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetGSTAndTaxSummaryReport } from "../services/reports.services";

const GSTAndTaxSummaryReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/gstandtaxsummaryreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/gstandtaxsummaryreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterGSTRate = params?.filterGSTRate;
  const filterUser = params?.filterUser;
  const BranchID = params?.BranchID;

  const loading = useAppSelector((state) => state.reports.loading);
  const GSTAndTaxSummaryListForReport = useAppSelector(
    (state) => state.reports.GSTAndTaxSummaryListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        GSTRate: filterGSTRate !== "0" ? filterGSTRate : 0,
        UserID: filterUser !== "0" ? filterUser : 0,
        BranchID: BranchID !== "0" ? BranchID : 0,
      };
      dispatch(GetGSTAndTaxSummaryReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "GSTAndTaxSummaryReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "gstandtaxsummaryreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          GST & Tax Summary Report{" "}
          <span style={{ fontSize: 15 }}>
            {GSTAndTaxSummaryListForReport &&
              GSTAndTaxSummaryListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            GSTAndTaxSummaryListForReport &&
            GSTAndTaxSummaryListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            GSTAndTaxSummaryListForReport &&
            GSTAndTaxSummaryListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {GSTAndTaxSummaryListForReport &&
      GSTAndTaxSummaryListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Invoice ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Trip ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Booking ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Customer Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  GST Rate (%)
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Taxable Value
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  GST Amount
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {GSTAndTaxSummaryListForReport &&
                GSTAndTaxSummaryListForReport.length > 0 &&
                GSTAndTaxSummaryListForReport?.map(
                  (GSTAndTaxSummary: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {GSTAndTaxSummary?.InvoiceID || ""}
                      </td>
                      <td className="text-center">
                        {GSTAndTaxSummary?.TripID || ""}
                      </td>
                      <td
                        className="text-center hoverableName"
                        onClick={() => {
                          navigate("/fitbooking/edit", {
                            state: {
                              FITBookingID: GSTAndTaxSummary?.TourBookingNo,
                            },
                          });
                        }}
                      >
                        {GSTAndTaxSummary?.TourBookingNo || ""}
                      </td>
                      <td className="text-center">
                        {GSTAndTaxSummary?.CustomerName || ""}
                      </td>
                      <td className="text-center">
                        {GSTAndTaxSummary?.GstPer || ""}
                      </td>
                      <td className="text-end">
                        {GSTAndTaxSummary?.TaxableValue
                          ? formatIndianNumber(GSTAndTaxSummary?.TaxableValue || "")
                          : ""}
                      </td>
                      <td className="text-end">
                        {GSTAndTaxSummary?.GstAmt
                          ? formatIndianNumber(GSTAndTaxSummary?.GstAmt || "")
                          : ""}
                      </td>
                      <td className="text-end">
                        {GSTAndTaxSummary?.TotalAmount
                          ? formatIndianNumber(
                              GSTAndTaxSummary?.TotalAmount || ""
                            )
                          : ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default GSTAndTaxSummaryReportView;
